import { typographyStyles } from "@newsela/angelou";

import { PrintModalZIndex } from "@/view/PrintSelector/PrintModal/PrintModal.style";

const { textXSObj } = typographyStyles;

export const toolTipIconCss = {
  width: "22px",
};

export const toolTipWrapperCss = {
  display: "flex",
  justifyContent: "space-between",
};

const toolTipButtonCss = {
  marginTop: "4px",
  marginRight: "16px",
};

const bodyTextCss = {
  ...textXSObj,
  lineHeight: "16px",
};

export const toolTipCss = {
  Button: {
    root: toolTipButtonCss,
  },
  dialog: {
    body: bodyTextCss,
    root: {
      zIndex: PrintModalZIndex + 1,
    },
  },
};
